import { useToastContext } from './ToastProvider';
import type { ToastVariant } from './Toast';

export interface UseToastReturn {
  showToast: (
    variant: ToastVariant,
    message: string,
    options?: { duration?: number; autoClose?: boolean }
  ) => string;
  success: (message: string, options?: { duration?: number; autoClose?: boolean }) => string;
  error: (message: string, options?: { duration?: number; autoClose?: boolean }) => string;
  warning: (message: string, options?: { duration?: number; autoClose?: boolean }) => string;
  info: (message: string, options?: { duration?: number; autoClose?: boolean }) => string;
  removeToast: (id: string) => void;
}

/**
 * Hook para mostrar notificaciones Toast
 *
 * @example
 * ```tsx
 * const toast = useToast();
 *
 * toast.success('Operación exitosa');
 * toast.error('Error al procesar');
 * toast.warning('Atención requerida');
 * toast.info('Información importante');
 * ```
 */
export function useToast(): UseToastReturn {
  const { showToast, success, error, warning, info, removeToast } = useToastContext();

  return {
    showToast,
    success,
    error,
    warning,
    info,
    removeToast,
  };
}

